module.exports = __webpack_public_path__ + "img/boxing-dark.b6e34b09.svg";